<template>
  <el-select
    v-model="origin"
    filterable
    placeholder="Select an Origin"
    :clearable="true"
  >
    <el-option
      v-for="item in origins"
      :key="item.id"
      :label="item.name"
      :value="item.id"
    />
  </el-select>
</template>

<script>
export default {
  name: 'Origin',
  computed: {
    origins() {
      return this.$store.getters['origins']
    },

    origin: {
      get() {
        return this.$store.getters['filters/origin']
      },
      set(value) {
        value = (value === '') ? null : value
        this.$store.commit('filters/origin', value)
      }
    }
  },
  beforeCreate() {
    this.$store.dispatch('getOrigins')
  }
}
</script>
